import React, { useState } from 'react';
import axios from 'axios';

const OutletData = () => {
  const [outletData, setOutletData] = useState({
    outletId: 2,
    outletLogo: '',
    Photo: [
      {
        photoId: '',
        photoName: '',
        PhotoUrl: '',
      },
    ],
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOutletData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle image change (base64 encoding)
  const handleImageChange = (e, target) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (target === "outletLogo") {
          setOutletData((prevData) => ({
            ...prevData,
            outletLogo: reader.result,
          }));
        } else if (target === "PhotoUrl") {
          setOutletData((prevData) => ({
            ...prevData,
            Photo: [
              {
                ...prevData.Photo[0],
                PhotoUrl: reader.result,
              },
            ],
          }));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  // Reset fields
  const resetFields = () => {
    setOutletData({
      outletId: 1,
      outletLogo: '',
      Photo: [
        {
          photoId: '',
          photoName: '',
          PhotoUrl: '',
        },
      ],
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("http://qrmenuapi.billtrace.in/api/Outlet/UpsertOutletImages", outletData);
      alert("Data saved successfully");
      resetFields(); // Reset form after successful submission
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving data. Please try again.");
    }
  };

  return (
    <div className="container mt-4">
      <h1 className="mb-4">Add Outlet Data</h1>
      <form onSubmit={handleSubmit} className="row g-3">
        {/* Outlet Logo */}
        <div className="col-md-6">
          <label htmlFor="outletLogo" className="form-label">Outlet Logo</label>
          <input
            type="file"
            id="outletLogo"
            accept="image/*"
            className="form-control"
            onChange={(e) => handleImageChange(e, "outletLogo")}
          />
          {outletData.outletLogo && (
            <div className="mt-2">
              <img
                src={outletData.outletLogo}
                alt="Outlet Logo Preview"
                className="img-thumbnail"
                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
              />
            </div>
          )}
        </div>

        <div className="col-md-6">
          <label htmlFor="photoId" className="form-label">Photo Id</label>
          <input
            type="text"
            id="photoId"
            name="photoId"
            className="form-control"
            value={outletData.Photo[0].photoId}
            onChange={(e) =>
              setOutletData((prevData) => ({
                ...prevData,
                Photo: [
                  {
                    ...prevData.Photo[0],
                    photoId: e.target.value,
                  },
                ],
              }))
            }
            required
          />
        </div>

        {/* Photo Name */}
        <div className="col-md-6">
          <label htmlFor="photoName" className="form-label">Photo Name</label>
          <input
            type="text"
            id="photoName"
            name="photoName"
            className="form-control"
            value={outletData.Photo[0].photoName}
            onChange={(e) =>
              setOutletData((prevData) => ({
                ...prevData,
                Photo: [
                  {
                    ...prevData.Photo[0],
                    photoName: e.target.value,
                  },
                ],
              }))
            }
            required
          />
        </div>

        {/* Photo URL */}
        <div className="col-md-6">
          <label htmlFor="photoUrl" className="form-label">Carousel Image</label>
          <input
            type="file"
            id="photoUrl"
            accept="image/*"
            className="form-control"
            onChange={(e) => handleImageChange(e, "PhotoUrl")}
          />
          {outletData.Photo[0].PhotoUrl && (
            <div className="mt-2">
              <img
                src={outletData.Photo[0].PhotoUrl}
                alt="Carousel Image Preview"
                className="img-thumbnail"
                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
              />
            </div>
          )}
        </div>

        {/* Submit Button */}
        <div className="col-12">
          <button type="submit" className="btn btn-primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default OutletData;

